import React, { useEffect } from 'react';

function InstagramRecruiting() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Recruiting Agentur für <span className="hero__highlight">Social Media & Instagram Recruiting</span> in Berlin
              </h1>
              <p className="hero__subtitle">
                Gezielt qualifizierte Bewerber erreichen mit professionellen Social Recruiting Kampagnen.
                Als spezialisierte Recruiting Agentur finden wir die besten Talente für Ihr Unternehmen über Instagram und Social Media.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Warum unsere Recruiting Agentur für Social Media & Instagram Recruiting die richtige Wahl ist</h2>
            <p className="section-subtitle">
              Als führende Social Media Recruiting Agentur in Berlin helfen wir Unternehmen dabei, gezielt qualifizierte Bewerber zu erreichen.
              Unsere Expertise im Bereich Social Media Recruiting kombiniert datengetriebene Ads mit authentischem Content, um potenzielle
              Kandidaten für Ihre offenen Stellen zu gewinnen.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>Was macht unsere Social Media Recruiting Agentur besonders?</h3>
              <p>
                Als spezialisierte <strong>Recruiting Agentur</strong> für Social Media haben wir uns auf Instagram Recruiting und innovative Social Recruiting Kampagnen fokussiert. Unsere Expertise liegt darin, gezielt qualifizierte Bewerber über Instagram und andere Social-Media-Plattformen zu erreichen. Im Gegensatz zu traditionellen Recruiting-Methoden nutzen wir die Macht von Social Media, um potenzielle Kandidaten dort anzusprechen, wo sie ihre Zeit verbringen – auf Instagram, Facebook und LinkedIn.
              </p>
              <p>
                Das Besondere an unserem Ansatz: Wir kombinieren datengetriebene <strong>Instagram Recruiting Ads</strong> mit authentischem Content, der Ihre Unternehmenskultur widerspiegelt. Durch gezielte Ansprache erreichen wir nicht nur aktiv auf der Suche befindliche Kandidaten, sondern auch potenzielle Bewerber, die momentan noch in Festanstellung sind, aber offen für neue Karrierechancen bleiben.
              </p>

              <h3>Wie funktioniert Instagram Recruiting konkret?</h3>
              <p>
                <strong>Instagram Recruiting</strong> basiert auf einer strategischen Kombination aus organischem Content und bezahlten Recruiting Ads. Als erfahrene Agentur entwickeln wir zunächst eine maßgeschneiderte Social Media Recruiting-Strategie, die perfekt zu Ihrem Unternehmen passt. Der gesamte Prozess beginnt mit einer detaillierten Analyse Ihrer Zielgruppe und der offenen Stellen, die Sie besetzen möchten.
              </p>
              <p>
                Im ersten Schritt erstellen wir authentische Einblicke in den Arbeitsalltag Ihres Unternehmens. Diese Stories, Reels und Posts zeigen potenzielle Kandidaten, wie es ist, bei Ihnen zu arbeiten. Gleichzeitig schalten wir gezielt Instagram Ads, die genau die Personen erreichen, die für Ihre Position qualifiziert sind.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">8-15€</span>
                  <span className="stat-box__label">Kosten pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">7-14 Tage</span>
                  <span className="stat-box__label">Bis erste Bewerbungen</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">15M+</span>
                  <span className="stat-box__label">Instagram Nutzer in Deutschland</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">90%</span>
                  <span className="stat-box__label">Erfolgsquote</span>
                </div>
              </div>

              <h3>Welche Branchen profitieren am meisten von Social Recruiting?</h3>
              <p>
                Unsere Erfahrung als <strong>Social Media Recruiting Agentur</strong> zeigt, dass nahezu jede Branche von Instagram Recruiting profitieren kann. Besonders erfolgreich sind jedoch Unternehmen im Sales-Bereich, IT-Sektor, in der Gastronomie, im E-Commerce und bei kreativen Dienstleistungen.
              </p>

              <div className="success-box">
                <h4>Praxisbeispiel: Tech-Unternehmen sucht Sales Manager</h4>
                <p>
                  Ein Berliner Tech-Unternehmen suchte einen Sales Manager und hatte über Jobbörsen keinen Erfolg. Unsere Recruiting Agentur entwickelte eine Instagram-Kampagne, die gezielt potenzielle Kandidaten mit Sales-Expertise ansprach. Innerhalb von 10 Tagen erhielten wir 18 qualifizierte Bewerbungen bei Kosten von nur 14€ pro Bewerbung.
                </p>
              </div>

              <h3>Was kostet Instagram Recruiting und welchen ROI können Sie erwarten?</h3>
              <p>
                Eine der häufigsten Fragen an unsere Recruiting Agentur betrifft die Kosten. Im Vergleich zu traditionellen Methoden ist Instagram Recruiting äußerst kosteneffizient. Während Personalvermittler oft 15-20% des Jahresgehalts berechnen und Jobbörsen monatliche Fixkosten verursachen, zahlen Sie bei uns nur für tatsächliche qualifizierte Bewerbungen.
              </p>

              <table className="comparison-table">
                <thead>
                  <tr>
                    <th>Methode</th>
                    <th>Kosten</th>
                    <th>Reichweite</th>
                    <th>Qualität</th>
                    <th>Geschwindigkeit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Jobbörsen</td>
                    <td>500-1500€/Monat</td>
                    <td>Begrenzt</td>
                    <td>Mittel</td>
                    <td>Langsam</td>
                  </tr>
                  <tr>
                    <td>Personalvermittler</td>
                    <td>20% Jahresgehalt</td>
                    <td>Hoch</td>
                    <td>Hoch</td>
                    <td>Mittel</td>
                  </tr>
                  <tr className="highlight-row">
                    <td><strong>Instagram Recruiting</strong></td>
                    <td><strong>8-15€/Bewerbung</strong></td>
                    <td><strong>Sehr hoch</strong></td>
                    <td><strong>Sehr hoch</strong></td>
                    <td><strong>Schnell</strong></td>
                  </tr>
                </tbody>
              </table>

              <h3>Unsere Instagram Recruiting Services im Detail</h3>
              
              <h4>1. Zielgruppenanalyse und Strategieentwicklung</h4>
              <p>
                Bevor wir mit der Content-Erstellung beginnen, analysieren wir Ihre Zielgruppe genau. Welche Altersgruppe sprechen Sie an? Welche Interessen haben Ihre potenziellen Mitarbeiter? Basierend auf diesen Erkenntnissen entwickeln wir eine maßgeschneiderte Instagram Recruiting Strategie.
              </p>

              <h4>2. Content Creation und Storytelling</h4>
              <p>
                Authentischer Content ist der Schlüssel zum Erfolg auf Instagram. Wir erstellen hochwertige Bilder, Videos und Stories, die Ihre Unternehmenskultur zeigen. Dabei legen wir großen Wert auf Storytelling – jede Kampagne erzählt eine Geschichte, die potenzielle Bewerber emotional anspricht.
              </p>
              <ul>
                <li>Behind-the-Scenes Einblicke in den Arbeitsalltag</li>
                <li>Mitarbeiterportraits und Erfolgsgeschichten</li>
                <li>Interaktive Stories und Umfragen</li>
                <li>Kreative Reels und TikTok-ähnliche Videos</li>
                <li>Hashtag-Kampagnen für maximale Reichweite</li>
              </ul>

              <h4>3. Gezielte Werbekampagnen</h4>
              <p>
                Instagram Ads sind ein mächtiges Tool für das Recruiting. Mit präzisen Targeting-Optionen können wir Ihre Anzeigen genau den Personen zeigen, die zu Ihrer Stellenbeschreibung passen.
              </p>
              <ul>
                <li>Zielgruppen-Targeting nach Alter, Interessen und Verhalten</li>
                <li>A/B-Testing verschiedener Anzeigenformate</li>
                <li>Retargeting von Website-Besuchern</li>
                <li>Lookalike-Audiences für erweiterte Reichweite</li>
                <li>Budget-Optimierung für maximale Effizienz</li>
              </ul>

              <h3>Erfolgsfaktoren für Instagram Recruiting in Berlin</h3>
              <p>
                Berlin ist ein Hotspot für Innovation und Kreativität. Hier treffen Start-ups auf etablierte Unternehmen, und der Wettbewerb um Talente ist hoch. Instagram Recruiting bietet die Möglichkeit, sich von der Konkurrenz abzuheben und authentisch zu kommunizieren.
              </p>
              <ul>
                <li><strong>Authentizität:</strong> Zeigen Sie Ihr Unternehmen so, wie es wirklich ist</li>
                <li><strong>Konsistenz:</strong> Regelmäßige Posts und Stories halten die Aufmerksamkeit</li>
                <li><strong>Interaktion:</strong> Beantworten Sie Kommentare und Nachrichten prompt</li>
                <li><strong>Visual Appeal:</strong> Hochwertige Bilder und Videos sind entscheidend</li>
                <li><strong>Call-to-Action:</strong> Klare Handlungsaufforderungen in jeder Kampagne</li>
              </ul>

              <h3>Instagram Recruiting Trends 2025 in Berlin</h3>
              <p>
                Die Recruiting-Landschaft verändert sich rasant, und Instagram passt sich an. Aktuelle Trends, die wir in unseren Kampagnen berücksichtigen:
              </p>
              <ul>
                <li><strong>Video-Content:</strong> Reels und Stories werden immer wichtiger</li>
                <li><strong>AR-Filter:</strong> Interaktive Filter für Employer Branding</li>
                <li><strong>Shopping-Features:</strong> Direkte Bewerbung über Instagram Shop</li>
                <li><strong>Live-Sessions:</strong> Q&A-Sessions mit Mitarbeitern</li>
                <li><strong>UGC (User-Generated Content):</strong> Inhalte von Mitarbeitern teilen</li>
              </ul>

              <h3>FAQ: Die wichtigsten Fragen zu Instagram Recruiting</h3>
              
              <div className="faq-item">
                <h4>Wie hoch ist die Erfolgsquote bei Instagram Recruiting?</h4>
                <p>
                  Unsere Erfolgsquote liegt bei über 90%. Das bedeutet: 9 von 10 Kampagnen generieren qualifizierte Bewerbungen innerhalb der ersten 14 Tage. Die durchschnittliche Kampagne bringt 15-25 qualifizierte Bewerbungen und führt zu 1-3 Einstellungen.
                </p>
              </div>

              <div className="faq-item">
                <h4>Funktioniert Instagram Recruiting auch für Festanstellungen?</h4>
                <p>
                  Absolut! Instagram eignet sich hervorragend für die Besetzung von Festanstellungen. Viele qualifizierte Kandidaten sind derzeit in Festanstellung, aber offen für neue Möglichkeiten. Durch unaufdringliche, authentische Ansprache erreichen wir diese "passiven Kandidaten".
                </p>
              </div>

              <div className="faq-item">
                <h4>Wie gezielt können wir Bewerber ansprechen?</h4>
                <p>
                  Extrem gezielt! Instagram bietet über 200 Targeting-Parameter, von demografischen Daten über Interessen bis hin zu Verhaltensweisen. Wir können beispielsweise gezielt Sales-Professionals ansprechen, die sich für Business-Themen interessieren, in Berlin leben und zwischen 25-35 Jahre alt sind.
                </p>
              </div>

              <div className="faq-item">
                <h4>Was kostet Instagram Recruiting?</h4>
                <p>
                  Die Kosten liegen zwischen 8-15€ pro qualifizierter Bewerbung. Keine Fixkosten, nur erfolgsbasierte Abrechnung. Im Vergleich zu Personalvermittlern (20% Jahresgehalt) oder Jobbörsen (500-1500€/Monat) ist Instagram Recruiting deutlich kosteneffizienter.
                </p>
              </div>

              <div className="faq-item">
                <h4>Wie lange dauert es bis zu ersten Bewerbungen?</h4>
                <p>
                  In der Regel erhalten unsere Kunden erste Bewerbungen nach 7-14 Tagen. Instagram wirkt besonders schnell bei jungen Zielgruppen und kreativen Branchen in Berlin.
                </p>
              </div>

              <div className="cta-box">
                <h3>Kostenlose Instagram Recruiting Analyse</h3>
                <p>
                  Möchten Sie wissen, wie Instagram Recruiting Ihr Unternehmen in Berlin voranbringen kann? Vereinbaren Sie jetzt Ihre kostenlose Analyse.
                </p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA">
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Instagram Recruiting Vorteile</h3>
                <ul>
                  <li>✓ 8-15€ pro Bewerbung</li>
                  <li>✓ 7-14 Tage bis erste Bewerbungen</li>
                  <li>✓ 67% der Berliner nutzen Instagram</li>
                  <li>✓ Authentische Arbeitgeberkommunikation</li>
                  <li>✓ Hohe Qualität der Bewerber</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Referenzen</h3>
                <p>Vertraut von führenden Berliner Unternehmen:</p>
                <ul>
                  <li>Vattenfall</li>
                  <li>REWE</li>
                  <li>Casio</li>
                  <li>AutoHero</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@social-recruiting-berlin.de">info@social-recruiting-berlin.de</a>
                </p>
                <button className="btn btn--primary btn--full" data-open-consultation data-source="Sidebar CTA">
                  Jetzt anfragen
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" style={{background: 'linear-gradient(135deg, #a387c1 0%, #C9B1D3 100%)', padding: '6rem 0'}}>
        <div className="container">
          <h2 className="cta-title" style={{color: 'white', textAlign: 'center', marginBottom: '1rem', fontSize: '2.5rem'}}>
            Bereit für erfolgreiches Instagram Recruiting in Berlin?
          </h2>
          <p className="cta-subtitle" style={{color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', fontSize: '1.25rem', marginBottom: '3rem'}}>
            Vereinbaren Sie jetzt Ihr kostenloses Erstgespräch und erfahren Sie, wie Instagram Recruiting Ihr Unternehmen voranbringt.
          </p>
          <div className="cta-buttons">
            <button className="btn btn--primary btn--large" data-open-consultation data-source="Bottom CTA" style={{background: 'white', color: '#a387c1', fontWeight: 700}}>
              Kostenloses Erstgespräch vereinbaren
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}

export default InstagramRecruiting;
